module.exports = __webpack_public_path__ + "static/media/parking_off.56cce1e4.svg";